import $ from 'jquery';
import _ from 'lodash';
import {isMobile} from '../utils/BrowserUtils';

const vulineTemplateClass = 'record-vuline-template';
const vulineTemplateClassAlt = 'record-subheading';

export function isVulineElement(domElem) {
  return (domElem.className === vulineTemplateClass || domElem.className === vulineTemplateClassAlt);
}

export function getVulineRenderer(publisherSlot) {
  const deviceMode = isMobile.any() ? 'mobile' : 'desktop';
  return _.find(publisherSlot.vulineRenderers, vr => _.includes(vr.devices, deviceMode));
}

export function isKeyFoundForProductPage(publisherSlot, publisherProductDataSource) {
  const vulineRenderer = getVulineRenderer(publisherSlot);
  if (!vulineRenderer) {
    return false;
  }
  const renderSearchSelector = publisherSlot.vulineSearchSelector;
  const {pageKey} = publisherProductDataSource;
  if (!pageKey) return false;

  const searchedText = formatTextForSearch(getDOMText(renderSearchSelector));
  if (!searchedText) return false;
  return searchedText.indexOf(pageKey) >= 0;
}

export function isSearchPhraseFound(rendererConfig) {
  const {renderSearchPhrases, renderSearchSelector, renderSearchPhraseRegex, cardId, adRenderer} = rendererConfig;
  if (!cardId && !adRenderer) {
    return true;
  }
  let isPhraseFound = false;
  const hasSearchPhrases = _.isArray(renderSearchPhrases) && !_.isEmpty(renderSearchPhrases) && !_.isEmpty(renderSearchPhrases[0]);
  if (hasSearchPhrases) {
    const searchedText = formatTextForSearch(getDOMText(renderSearchSelector));
    isPhraseFound = containsPhrase(renderSearchPhrases, searchedText);
  } else if (renderSearchPhraseRegex) {
    const re = new RegExp(renderSearchPhraseRegex, 'ig');
    isPhraseFound = re.test(formatTextForSearch(getDOMText(renderSearchSelector)));
  }

  return isPhraseFound;
}

export function isExclusionPhraseFound(exclusionSelector, exclusionPhrases) {
  if (!exclusionSelector) {
    return false;
  }

  let isExclusionFound = false;
  const hasExclusionPhrases = _.isArray(exclusionPhrases) && !_.isEmpty(exclusionPhrases) && !_.isEmpty(exclusionPhrases[0]);
  if (hasExclusionPhrases) {
    const searchedText = formatTextForSearch(getDOMText(exclusionSelector));
    isExclusionFound = containsPhrase(exclusionPhrases, searchedText);
  }
  return isExclusionFound;
}

function getDOMText(includeSelector) {
  if (includeSelector) {
    return $(includeSelector).text();
  }

  return getDeepElementText(document.body).join(' ');
}

function getDeepElementText(elem) {
  let A = [],
tx;
  if (elem) {
    elem = elem.firstChild;
    while (elem != null) {
      if (elem.nodeType === 3) {
        const {parentElement} = elem;
        if (!parentElement || !isVulineElement(parentElement)) {
          tx = (elem.data || '').trim();
          if (/\S/.test(tx)) A[A.length] = tx;
        }
      } else A = A.concat(getDeepElementText(elem));
      elem = elem.nextSibling;
    }
  }
  return A;
}

export function containsPhrase(searchPhrases, searchText) {
  let result = false;

  if (!searchText) {
    return false;
  }

  for (let i = 0; i < searchPhrases.length; i++) {
    let isSingleFound = false,
      singleSearchList = searchPhrases[i];

    if (!_.isEmpty(singleSearchList)) {
      isSingleFound = true;
      for (let j = 0; j < singleSearchList.length; j++) {
        if (searchText.indexOf(singleSearchList[j]) < 0) {
          isSingleFound = false;
          break;
        }
      }
    }
    result = result || isSingleFound;
  }

  return result;
}

export function formatTextForSearch(text) {
  if (text) {
    return replaceNbsps(text.toLowerCase());
  }
  return '';
}

function replaceNbsps(str) {
  const re = new RegExp(String.fromCharCode(160), 'g');
  return str.replace(re, ' ');
}

export function getSurroundingTexts(text, adjacentText, searchPhrase) {
  adjacentText = adjacentText || '';
  let results = [],
    searchedText = formatTextForSearch(text),
    restOfText = text;
  let indexFound = searchedText.indexOf(searchPhrase);
  const specialEndings = {
    1: ['"', '”', ')', ']', '>'],
    2: [',"', ',”', '?"', '?”', '."', '.”']
  };

  const excludeEndings = {
    1: [],
    2: ['\'s', '’s']
  };

  while (indexFound >= 0) {
    let splitText;
    const splitIndex = (indexFound + searchPhrase.length);
    const nextChar = restOfText[splitIndex];
    const lastTwoChars = restOfText.substring(splitIndex, splitIndex + 2);

    const foundExclusionEnding = (excludeEndings[1].indexOf(nextChar) >= 0) || (excludeEndings[2].indexOf(lastTwoChars) >= 0);
    const foundExclusionEndingInAdjacentText = (splitIndex === searchedText.length) &&
      _.some(excludeEndings[2], ending => _.startsWith(adjacentText, ending));
    const shouldIgnorePhrase = foundExclusionEnding || foundExclusionEndingInAdjacentText;

    if (shouldIgnorePhrase) {
      const rest = searchedText.substring(splitIndex, searchedText.length);
      const newIndexFound = rest.indexOf(searchPhrase);
      indexFound = (newIndexFound >= 0) ? (splitIndex + newIndexFound) : newIndexFound;
      continue;
    }

    if (specialEndings[1].indexOf(nextChar) >= 0) {
      splitText = restOfText.substring(0, splitIndex + 1);
      searchedText = searchedText.substring(splitIndex + 1, searchedText.length);
      restOfText = restOfText.substring(splitIndex + 1, restOfText.length);
    } else if (specialEndings[2].indexOf(lastTwoChars) >= 0) {
      splitText = restOfText.substring(0, splitIndex + 2);
      searchedText = searchedText.substring(splitIndex + 2, searchedText.length);
      restOfText = restOfText.substring(splitIndex + 2, restOfText.length);
    } else {
      splitText = restOfText.substring(0, splitIndex);
      searchedText = searchedText.substring(splitIndex, searchedText.length);
      restOfText = restOfText.substring(splitIndex, restOfText.length);
    }

    splitText += ' ';
    results.push(splitText);
    indexFound = searchedText.indexOf(searchPhrase);
  }
  if (restOfText) {
    results.push(restOfText);
  }
  return results;
}

export function getSurroundingTextsForPhrase(text, phraseToReplace, isRegex = false) {
  const results = [];
  let searchedText = formatTextForSearch(text);
  let restOfText = text;

  if (!isRegex) {
    let indexFound = searchedText.indexOf(phraseToReplace);

    while (indexFound >= 0) {
      const beforeIndex = indexFound;
      const afterIndex = (indexFound + phraseToReplace.length);
      const before = restOfText.substring(0, beforeIndex),
        phrase = restOfText.substring(beforeIndex, afterIndex);

      restOfText = restOfText.substring(afterIndex, restOfText.length);
      searchedText = searchedText.substring(afterIndex, searchedText.length);

      results.push({before, phrase});
      indexFound = searchedText.indexOf(phraseToReplace);
    }
    results.push({before: restOfText, phrase: null});
  } else {
    const regexPhraseToReplace = new RegExp(phraseToReplace, 'ig');
    let lastEnd = 0;
    let matchResult;
    // eslint-disable-next-line no-cond-assign
    while ((matchResult = regexPhraseToReplace.exec(text)) !== null) {
      const phrase = matchResult[0];
      const before = text.substring(lastEnd, matchResult.index);
      lastEnd = regexPhraseToReplace.lastIndex;
      results.push({before, phrase});
    }
    if (lastEnd < text.length - 1) {
      results.push({before: text.substring(lastEnd), phrase: null});
    }
  }
  return results;
}
